import { render, staticRenderFns } from "./_LargeDonutChart.vue?vue&type=template&id=5bc6d0c4&scoped=true"
import script from "./_LargeDonutChart.vue?vue&type=script&lang=js"
export * from "./_LargeDonutChart.vue?vue&type=script&lang=js"
import style0 from "./_LargeDonutChart.vue?vue&type=style&index=0&id=5bc6d0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6d0c4",
  null
  
)

export default component.exports